export function Brand() {
  return <span className="inline-flex shrink-0 items-center gap-2.5">
    <img src="/nexra-mark.svg" width={32} height={32} alt="" />
    <span className="text-xl font-semibold tracking-tight text-foreground max-[420px]:hidden">nexra</span>
  </span>;
}
